import {
  AddressView,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@gearbox-protocol/deploy-tools-ui";
import { TokenSymbol } from "@gearbox-protocol/ui-kit";
import type { FC } from "react";
import type { Address } from "viem";

export interface TokenSelectorProps {
  label: string;
  value?: Address;
  onChange: (value: Address) => void;
  values: Array<{ token: Address; symbol: string }>;
}

export const TokenSelector: FC<TokenSelectorProps> = props => {
  const { label, value, onChange, values } = props;
  return (
    <div className="grid grid-cols-values-2 gap-2">
      <div className="flex items-center">
        <Label>{label}</Label>
      </div>
      <div>
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder={label} />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>Tokens</SelectLabel>
              {values.map(({ token, symbol }) => (
                <SelectItem key={token} value={token}>
                  <TokenSymbol token={symbol} showSymbol size={18} />
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      <div />
      <div>
        <AddressView
          address={value ?? "0x0"}
          className="text-mono text-sm"
          compact
        />
      </div>
    </div>
  );
};
